import React from "react";
import { leaf } from "../../assets";
import { useState } from "react";
import { BsBookmarkPlus } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";

const SubDoctor = ({ singleDoc }) => {
  const [bookingPopup, setBookingPopup] = useState(false);
  const [bookingData, setBookingData] = useState({
    doctor: singleDoc?.name,
  });
  const [payMethod, setPayMethod] = useState("");

  const closePopup = (e) => {
    e.preventDefault();
    setBookingPopup(false);
    setBookingData({ doctor: singleDoc?.name });
  };

  const openPopup = () => {
    setBookingPopup(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(bookingData);

    //post on DB
    fetch("https://laser-treat-server.onrender.com/single-bookings/save", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bookingData),
    });

    toast.success(`Appointment has been booked successfully`, {
      position: "top-center",
      autoClose: 3000,
    });

    setBookingPopup(false);
    setBookingData({ doctor: singleDoc?.name });
  };

  const submitPayment = (e) => {
    e.preventDefault();

    fetch("https://laser-treat-server.onrender.com/ssl-init", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bookingData),
    })
      .then((res) => res.json())
      .then((data) => {
        window.location.replace(data?.url);
      });
  };

  const handleInputs = (e) => {
    setBookingData({ ...bookingData, [e.target.name]: e.target.value });
  };

  const handlePayMethod = (e) => {
    setPayMethod(e.target.value);
    setBookingData({ ...bookingData, payMethod: e.target.value });
  };
  return (
    <>
      {Object.keys(singleDoc).length !== 0 ? (
        <div id="subDoctor">
          {bookingPopup && (
            <div className="booking-popup">
              <form
                onSubmit={payMethod === "cod" ? handleSubmit : submitPayment}
              >
                <div className="inp-grp">
                  <label>Full Name</label>
                  <input
                    required
                    type="text"
                    placeholder="Enter full name"
                    name="fullName"
                    onChange={handleInputs}
                  />
                </div>
                <div className="inp-grp">
                  <label>Date</label>
                  <input
                    required
                    type="date"
                    name="date"
                    onChange={handleInputs}
                  />
                </div>
                <div className="inp-grp">
                  <label>Phone</label>
                  <input
                    required
                    type="number"
                    placeholder="Enter phone number"
                    name="phone"
                    onChange={handleInputs}
                  />
                </div>
                <div className="inp-grp">
                  <label>Email</label>
                  <input
                    required
                    type="email"
                    placeholder="Enter email"
                    name="userEmail"
                    onChange={handleInputs}
                  />
                </div>
                <div className="inp-grp">
                  <label>Booking Reason</label>
                  <textarea
                    required
                    placeholder="Enter message"
                    name="message"
                    onChange={handleInputs}
                  />
                </div>
                <div className="payment-method">
                  <p>Choose a Payment Method: </p>
                  <div className="radio-el">
                    <label>
                      <input
                        required
                        type="radio"
                        name="payment-type"
                        value="cod"
                        onChange={handlePayMethod}
                      />
                      COD
                    </label>
                    {/* <label>
                      <input
                        required
                        type="radio"
                        name="payment-type"
                        value="online payment"
                        onChange={handlePayMethod}
                      />
                      Online Payment
                    </label> */}
                  </div>
                  {/* {payMethod === "online payment" && (
                    <p>
                      Appointment Charge <span>BDT 500/-</span>
                    </p>
                  )} */}
                </div>
                <div className="btns">
                  <button type="submit">Confirm</button>
                  <button onClick={closePopup}>Cancel</button>
                </div>
              </form>
            </div>
          )}
          <div className="highlight">
            <div className="left">
              <img src={singleDoc?.doc} alt="" />

              <button onClick={openPopup} className="singleBook">
                Book Appointment
              </button>
            </div>
            <div className="right">
              <h1>{singleDoc?.name}</h1>

              <div className="education">
                <p>{singleDoc?.edu}</p>
              </div>
              <div className="specialities">
                <div>
                  <img src={leaf} alt="" />
                  <h2>Specialities</h2>
                </div>
                <div className="items">
                  <p className="exp">{singleDoc?.exp}+ Years Experience</p>
                  <p>{singleDoc?.sp1 && singleDoc?.sp1}</p>
                  <p>{singleDoc?.sp2 && singleDoc?.sp2}</p>
                  {singleDoc?.sp3 && <p>{singleDoc?.sp3 && singleDoc?.sp3}</p>}
                </div>
              </div>
              <div className="area">
                <p>
                  <span>Consultant</span> of Laser Treat & Dhaka Dermatology
                  Institute
                </p>
                {singleDoc?.highlight && (
                  <p>
                    <span>{singleDoc?.highlight}</span> of Aesthetic Dermatology
                    Society of Bangladesh (ADSB)
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="fullDesc">
            <div className="left">
              <p>{singleDoc.desc1}</p>
              <p style={{ fontWeight: "bold" }}>{singleDoc.desc2}</p>
            </div>
            <div className="right">
              <div className="title">
                <img src={leaf} alt="" />
                <h2>ADVANCE TRANING IN</h2>
              </div>
              <div className="trainings">
                <div className="item">
                  <p className="bold">Aesthetic Medicine</p>
                  <p>American Academy of Aesthetic Medicine (USA)</p>
                </div>
                <div className="item">
                  <p className="bold">{singleDoc.adSub && singleDoc.adSub}</p>
                  <p>{singleDoc.adLoc && singleDoc.adLoc}</p>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      ) : (
        <div className="noDoc">
          <img src={leaf} alt="" width={50} />
          <h2>Opps! Something went wrong</h2>
          <p>
            Please select a doctor from{" "}
            <Link to="/specialist">Specialists</Link>
          </p>
        </div>
      )}
    </>
  );
};

export default SubDoctor;
